import { date } from '@/lib/date';
import { Role } from 'generated/prisma/enums';
import z from 'zod';

const passwordSchema = z
  .string('Campo obrigatório.')
  .min(8, 'Use ao menos 8 caracteres.')
  .regex(/[A-Z]/, 'Deve conter pelo menos uma letra maiúscula!')
  .regex(/[a-z]/, 'Deve conter pelo menos uma letra minúscula!')
  .regex(/[0-9]/, 'Deve conter pelo menos um número!')
  .regex(/[^A-Za-z0-9]/, 'Deve conter pelo menos um caractere especial!');

export const createUserSchema = z.object({
  name: z.string('Campo obrigatório.').trim().min(1, 'Campo obrigatório.'),
  email: z.email('Informe um e-mail válido.'),
  password: passwordSchema,
  role: z.enum(Role, 'Selecione uma opção.'),
  isActive: z.boolean().optional(),
});

export const updateUserSchema = z.object({
  name: z.string('Campo obrigatório.').trim().min(1, 'Campo obrigatório.'),
  email: z.email('Informe um e-mail válido.'),
  /** Em branco mantém a senha atual. */
  password: z.preprocess((val) => val || undefined, passwordSchema.optional()),
  role: z.enum(Role, 'Selecione uma opção.').optional(),
  isActive: z.boolean('Valor inválido').optional(),
});

export type CreateUserSchema = z.input<typeof createUserSchema>;
export type UpdateUserSchema = z.input<typeof updateUserSchema>;
